// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-relationInformation":"jobSearchDetail-relationInformation","jobSearchDetail-relationInformation__body":"jobSearchDetail-relationInformation__body"};